import home from './home'
import service from './service'
import tech from './tech'
import advantage from './advantage'
import aboutUs from './aboutUs'
import roadMap from './roadMap'
import product from './product'

import {scI18nBuilder} from "../util"

let textArr = [
  home, service, tech, advantage, aboutUs, roadMap, product
]

let i18n = scI18nBuilder(textArr)

export default {
  i18n
}